export const _order = (data: any[], orderId: number[]) => {
    const dataObject = {};
    const dataWithOutId = [];
    data.forEach((item) => {
        if (item.id) {
            dataObject[item.id] = item;
        } else {
            dataWithOutId.push(item);
        }
    });

    const dataInOrderIdList = [];
    orderId.forEach((id) => {
        if (!!dataObject[id]) {
            dataInOrderIdList.push(dataObject[id]);
        }
    });

    const dataNotInOrderIdList = [];
    Object.keys(dataObject).forEach((id) => {
        if (!orderId.includes(+id)) {
            dataNotInOrderIdList.push(dataObject[id]);
        }
    });

    return [...dataInOrderIdList, ...dataNotInOrderIdList, ...dataWithOutId];
};

export const reorder = (list, startIndex, endIndex) => {
    const result = Array.from(list);
    const [removed] = result.splice(startIndex, 1);
    result.splice(endIndex, 0, removed);

    return result;
};
